import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';

import React from 'react';
import PropTypes from 'prop-types';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { useModal } from '../../../../hooks/use-modal';
import { ModalPortal } from '../../../../components/modal-portal';
import { MULTI_PACKAGE_MODAL_CONTEXTS, MultiPackageModal } from '../../../../components/modals/multi-package-modal';

import { messages } from './messages';
import style from './style.module.css';

/**
 * A reusable button component for adding a package set
 * @param {object} props
 * @param {string} [props.className] - Additional class name for the FlexRow wrapper
 * @returns {React.ReactNode}
 */
export const AddPackageSetButton = ({ className }) => {
  const { isOpen, open, close } = useModal();
  return (
    <FlexRow className={className || style['add-package-set-button-row']}>
      <Button onClick={open} theme='primary'>
        <FlexRow className={style['add-package-set-button-content']}>
          <FontAwesomeIcon className={style.icon} icon={faPlus} />
          <Text textType={TextType.Caption} value={messages.addPackageSetButton} />
        </FlexRow>
      </Button>
      {isOpen && (
        <ModalPortal onClose={close}>
          <MultiPackageModal context={MULTI_PACKAGE_MODAL_CONTEXTS.Settings} onSave={close} />
        </ModalPortal>
      )}
    </FlexRow>
  );
};

AddPackageSetButton.propTypes = {
  onClick: PropTypes.func,
  className: PropTypes.string,
};
